/*eslint-disable*/
import React, { Component } from "react";
import { Accordion, Menu } from "semantic-ui-react";
import SubLink from './sublink';
const Masters = (
    <div >
        <SubLink subLink="Vehicle" To="/vehicle" />
        <SubLink subLink="Vehicle Type" To="/vehicle-type" />
        <SubLink subLink="Branch" To="/branch" />
        <SubLink subLink="Vendor" To="/vendor" />
        {/* <SubLink subLink="Vendor Type" To="/vendor-type" /> */}
        <SubLink subLink="Jobcard Type" To="/jobcard-type" />
        <SubLink subLink="Product" To="/product" />
        <SubLink subLink="Service" To="/service" />
        <SubLink subLink="User" To="/users" />
        <SubLink subLink="Tyre Inventory" To="/tyre-inventory" />
        <SubLink subLink="Tyre Position" To="/tyre-position" />
        <SubLink subLink="Battery Inventory" To="/battery-inventory" />
        <SubLink subLink="Category" To="/category" />
        {/* <SubLink subLink="Checklist" To="/checklistmaster" /> */}
        <SubLink subLink="Make" To="/make" />
        <SubLink subLink="Model" To="/model" />
        <SubLink subLink="Insurance Company" To="/insurance-company" />
    </div>
);

const Reports = (
    <div>
        {localStorage.getItem('customerNo') == 503 || localStorage.getItem('customerNo') == 1371
            ?
            <>
                <SubLink subLink={localStorage.getItem('customerNo') == 503 ? "Document Expiry Report" : "Vehicle Document Report"} To="/VehicleDocumentReport?VEHICLE_DOCUMENT_REPORT" type="VEHICLE_DOCUMENT_REPORT" />
                <SubLink subLink="Current Month Jobcard Analysis" To="/CurrentMonthJobcardAnalysis?CURRENT_MONTH_JOBCARD_ANALYSIS" type='CURRENT_MONTH_JOBCARD_ANALYSIS' />
                <SubLink subLink="Fuel mileage Report" To="/fuelmileage" />
                <SubLink subLink="Consolidated Fuel mileage Report" To="/ConsolidatedFuelmileage" />
                <SubLink subLink="Transaction History Report" To="/TransactionHistoryReport?TRANSACTION_HISTORY_REPORT" type="TRANSACTION_HISTORY_REPORT" />
                <SubLink subLink="Current Tyre Run Report" To="/CurrentTyreRunReport?CURRENT_TYRE_RUN_REPORT" type="CURRENT_TYRE_RUN_REPORT" />
                <SubLink subLink="Historic Tyre Run Report" To="/HistoricTyreRunReport?HISTORIC_TYRE_RUN_REPORT" type="HISTORIC_TYRE_RUN_REPORT" />
                <SubLink subLink="Historic Battery Report" To="/HistoricBatteryRunReport?HISTORIC_BATTERY_REPORT" type="HISTORIC_BATTERY_REPORT" />

            </>
            :
            null
        }
    </div>
);


export default class AccordionExampleMenu extends Component {
    state = { activeIndex: 0 };

    handleClick = (e, titleProps) => {
        console.log(titleProps,'titleProps')
        console.log(this.state.activeIndex,'activeIndex')
        const { index } = titleProps;
        const { activeIndex } = this.state;
        const newIndex = activeIndex === index ? -1 : index;

        this.setState({ activeIndex: newIndex });
    };

    render() {
        const { activeIndex } = this.state;
        return (
            <Accordion as={Menu} vertical style={{ backgroundColor: "#2D373C", width: "100%" }}>
                <Menu.Item className="mb-3 accordionStyle">
                    <Accordion.Title
                        className="w3-text-white w3-small"
                        active={activeIndex === 1}
                        content={<div className="nav-link p-hover p-3 w3-text-white checklink stylefont">
                            <img className="ml-2" src="assets/svg/master.svg" alt="Masters" width="18" />
                            <span className="labelName">&nbsp;&nbsp;&nbsp;&nbsp;Masters</span>
                        </div>}
                        index={1}
                        onClick={this.handleClick}
                    />
                    <Accordion.Content active={activeIndex === 1} content={Masters} />
                </Menu.Item>
                <Menu.Item className="mb-3 accordionStyle">
                    <Accordion.Title
                        className="w3-text-white w3-small mb-1"
                        active={activeIndex === 2}
                        content={<div className="nav-link p-hover p-3 w3-text-white checklink stylefont">
                            <img className="ml-2" src="assets/svg/report.svg" alt="Reports" width="18" />
                            <span className="labelName">&nbsp;&nbsp;&nbsp;&nbsp;Report</span>
                        </div>}
                        index={2}
                        onClick={this.handleClick}
                    />
                    <Accordion.Content active={activeIndex === 2} content={Reports} />
                </Menu.Item>
            </Accordion>
        );
    }
}
